module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold-slnt=0.c6588ec.ttf";